import 'page-scroll-to-id/jquery.malihu.PageScroll2id';
import './footer.scss';

export default (() => {
	$(document).ready(function () {
		$('a[href*=\'#header\']').mPageScroll2id();

		if ($('body').hasClass('front-page')) {
			$('footer').addClass('footer--green');
		}
	});
})();
